import React from 'react';

const Maintenance = () => {
    return (
        <div className="container text-center py-5">
            <div className="row">
                <div className="col">
                    <h3 className="mt-5">We Have The Best Maintenance Team Also</h3>
                    <p>You Can Find Us Below</p>
                    <ul className="d-inline-block">
                        <li>
                            <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">Email: Email@example.net</a>
                        </li>
                        <li>
                            <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">Website: www.company.net</a>
                        </li>
                        <li>
                            <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">Tel: 555-666-7777</a>
                        </li>
                        <li>
                            <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">Cell: +4-5556-845-55</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Maintenance;
